module.exports = __webpack_public_path__ + "img/login.6a12e1f3.png";